import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  tableHeader: TableHeadersType[] | [];
  leadDirectoryList: [] | any[];
  openDrawer: (data: any) => void;
  offset: number;
};

const LeadModuleFirstColumnTableData = ({
  tableHeader,
  leadDirectoryList,
  openDrawer,
  offset,
}: AppProps) => {
  const calMAxLen = () => {
    let maxLength = 0;
    let height = 0;
    leadDirectoryList?.map((data) => {
      maxLength =
        maxLength > data?.company_name?.length
          ? maxLength
          : data?.company_name?.length;
    });
    if (maxLength > 0 && maxLength <= 30) {
      height = 60;
    } else if (maxLength > 30 && maxLength < 100) {
      height = 90;
    } else {
      height = 120;
    }
    return 90;
  };
  return (
    <>
      {leadDirectoryList?.length > 0 &&
        leadDirectoryList?.map((LeadModuleListData: any) => {
          return (
            <tr
              className="text-left"
              style={{
                lineHeight: "0.23",
                height: `${calMAxLen()}px`,
              }}
            >
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value == "company_name") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{
                          maxWidth: "400px",
                          whiteSpace: "normal",
                          textDecoration: "underline",
                          fontWeight: "600",
                          cursor: "pointer",
                        }}
                        onClick={() => openDrawer(LeadModuleListData)}
                      >
                        {" "}
                        <div
                          style={{
                            paddingTop: "1px",
                            minWidth: "180px",
                            overflowWrap: "break-word",
                            lineHeight: "1.5",
                          }}
                        >
                          {LeadModuleListData?.company_name?.length > 50 ? (
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view">
                                  {`${LeadModuleListData?.company_name}(${LeadModuleListData?.client_code})`}
                                </Tooltip>
                              }
                            >
                              <span>
                                {`${LeadModuleListData?.company_name
                                  .toLowerCase()
                                  .substr(0, 50)}${
                                  LeadModuleListData?.company_name?.length > 50
                                    ? "..."
                                    : ""
                                }`}
                              </span>
                            </OverlayTrigger>
                          ) : LeadModuleListData?.company_name ? (
                            `${LeadModuleListData?.company_name} (${LeadModuleListData?.client_code})`
                          ) : (
                            "--/--"
                          )}
                        </div>
                      </td>
                    );
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default LeadModuleFirstColumnTableData;
